export default {
  data() {
    return {
      searchText: '',
      searchTextTimeout: null,
    };
  },
  watch: {
    searchText(newVal) {
      clearTimeout(this.searchTextTimeout);
      this.searchTextTimeout = setTimeout(() => {
        this.searchParams.search_contact = newVal;
      }, 500);
    },
  },
};
